import { Pipe, PipeTransform } from '@angular/core';
import { DecimalRuleDescription } from '@ui-lib/components';
import { numberToSolHashrate } from '../utils/sol-hashrate.function';

export type SolHashrateMode = 'full' | 'onlyLabel' | 'onlyDigit';

@Pipe({
  name: 'solHashrate',
  standalone: true,
})
export class SolHashratePipe implements PipeTransform {
  public transform(
    value: number | undefined,
    mode: SolHashrateMode = 'full',
    rule?: DecimalRuleDescription,
  ): string {
    const { hashRate, literal } = numberToSolHashrate(value, rule);

    switch (mode) {
      case 'onlyDigit':
        return `${hashRate}`;
      case 'onlyLabel':
        return literal;
      case 'full':
      default:
        return `${hashRate} ${literal}`;
    }
  }
}
